export const FRENCH_LOCALE = 'fr-CA';
export const HELP_DESK_ENGLISH_LOCALE = 'en';
export const HELP_DESK_FRENCH_LOCALE = 'fr';
export const PROJECTS_FOR_AE = ['published', 'archived', 'draft'];
